require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/set-prototype-of.js
// module id = ./node_modules/core-js/library/fn/object/set-prototype-of.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons